export function echoError(message) {
  var _console, _console2;
  if (typeof ((_console = console) === null || _console === void 0 ? void 0 : _console.error) === 'function') {
    console.error(message);
  } else if (typeof ((_console2 = console) === null || _console2 === void 0 ? void 0 : _console2.log) === 'function') {
    console.log(message);
  }
}